import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiAnnuaireService } from '../services/api-annuaire.service';


@Component({
  selector: 'app-annuaire-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.css'],
  providers: []
})
export class ListingComponent implements OnInit {
  criteres;
  paged : number = 1;
  loading = false;

  titleFormatted = '';
  
  @Input() total = 0;
  @Input() entreprises = [];

  constructor(private _apiService : ApiAnnuaireService) {
    
    console.log('entreprises : ', this.entreprises);
  }

  ngOnInit() {
    console.log('- INIT LISTING -', this.entreprises);
    this.criteres = this._apiService.getAnnuaireFormDatas();
  }

  ngDoCheck() {
    console.log('DOCHECK : ', this.entreprises);
  }

  onClickMoreResults() {
    console.log('more');
    this.paged++;
    this.loading = true;

    this._apiService.getEntreprisesByFilter(this.paged).then(results => {
      if (results) {
        this.entreprises = this.entreprises.concat(results.results);
        this.loading =false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/annuaire/listing/listing.component.ts